import {
  CIRRUS_FACEBOOK_SOC,
  CIRRUS_TWITTER_SOC,
  CIRRUS_INSTAGRAM_SOC,
  CIRRUS_LINKEDIN_SOC,
} from '@/constants/pagesUrl.js';

const Socials = [
  {
    name: 'Facebook',
    url: CIRRUS_FACEBOOK_SOC,
    icon: 'social-facebook',
  },
  {
    name: 'Twitter',
    url: CIRRUS_TWITTER_SOC,
    icon: 'social-twitter',
  },
  {
    name: 'Instagram',
    url: CIRRUS_INSTAGRAM_SOC,
    icon: 'social-instagram',
  },
  {
    name: 'LinkedIn',
    url: CIRRUS_LINKEDIN_SOC,
    icon: 'social-linked-in',
  },
];

export default Socials;
